/**
 * @generated SignedSource<<5f7a27231d5fb1fb10fa3408afaf9625>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type projectNotificationsConfigTable_personalSettingsNotificationsConfigTable_ProjectNotificationConfigTableNew_projectPreferencesData$data = {
  readonly preferences: {
    readonly issueAssigned: {
      readonly " $fragmentSpreads": FragmentRefs<"notificationsConfigRow_personalSettingsNotificationsConfigTable_preference">;
    };
    readonly mentionsCombined: {
      readonly " $fragmentSpreads": FragmentRefs<"notificationsConfigRow_personalSettingsNotificationsConfigTable_preference">;
    };
    readonly miscellaneousIssueEventCombined: {
      readonly " $fragmentSpreads": FragmentRefs<"notificationsConfigRow_personalSettingsNotificationsConfigTable_preference">;
    };
    readonly worklogCombined: {
      readonly " $fragmentSpreads": FragmentRefs<"notificationsConfigRow_personalSettingsNotificationsConfigTable_preference">;
    };
    readonly " $fragmentSpreads": FragmentRefs<"notificationsAccordianRow_personalSettingsNotificationsConfigTable_NotificationsConfigRow_allPreferences" | "notificationsConfigHead_personalSettingsNotificationsConfigTable_HeadCheckbox_allPreferences" | "notificationsConfigRow_personalSettingsNotificationsConfigTable_allPreferences">;
  };
  readonly project: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"projectNotificationsAccordion_personalSettingsNotificationsConfigTable">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"projectNotificationsRemoveButton_personalSettingsNotificationsConfigTable_RemoveButton">;
  readonly " $fragmentType": "projectNotificationsConfigTable_personalSettingsNotificationsConfigTable_ProjectNotificationConfigTableNew_projectPreferencesData";
};
export type projectNotificationsConfigTable_personalSettingsNotificationsConfigTable_ProjectNotificationConfigTableNew_projectPreferencesData$key = {
  readonly " $data"?: projectNotificationsConfigTable_personalSettingsNotificationsConfigTable_ProjectNotificationConfigTableNew_projectPreferencesData$data;
  readonly " $fragmentSpreads": FragmentRefs<"projectNotificationsConfigTable_personalSettingsNotificationsConfigTable_ProjectNotificationConfigTableNew_projectPreferencesData">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "FragmentSpread",
    "name": "notificationsConfigRow_personalSettingsNotificationsConfigTable_preference"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "projectNotificationsConfigTable_personalSettingsNotificationsConfigTable_ProjectNotificationConfigTableNew_projectPreferencesData",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "projectNotificationsRemoveButton_personalSettingsNotificationsConfigTable_RemoveButton"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "id"
            },
            "action": "THROW",
            "path": "project.id"
          },
          {
            "kind": "FragmentSpread",
            "name": "projectNotificationsAccordion_personalSettingsNotificationsConfigTable"
          }
        ]
      },
      "action": "THROW",
      "path": "project"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraNotificationPreferences",
        "kind": "LinkedField",
        "name": "preferences",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "notificationsConfigHead_personalSettingsNotificationsConfigTable_HeadCheckbox_allPreferences"
          },
          {
            "kind": "FragmentSpread",
            "name": "notificationsAccordianRow_personalSettingsNotificationsConfigTable_NotificationsConfigRow_allPreferences"
          },
          {
            "kind": "FragmentSpread",
            "name": "notificationsConfigRow_personalSettingsNotificationsConfigTable_allPreferences"
          },
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraNotificationPreference",
              "kind": "LinkedField",
              "name": "issueAssigned",
              "plural": false,
              "selections": (v0/*: any*/)
            },
            "action": "THROW",
            "path": "preferences.issueAssigned"
          },
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraNotificationPreference",
              "kind": "LinkedField",
              "name": "mentionsCombined",
              "plural": false,
              "selections": (v0/*: any*/)
            },
            "action": "THROW",
            "path": "preferences.mentionsCombined"
          },
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraNotificationPreference",
              "kind": "LinkedField",
              "name": "worklogCombined",
              "plural": false,
              "selections": (v0/*: any*/)
            },
            "action": "THROW",
            "path": "preferences.worklogCombined"
          },
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraNotificationPreference",
              "kind": "LinkedField",
              "name": "miscellaneousIssueEventCombined",
              "plural": false,
              "selections": (v0/*: any*/)
            },
            "action": "THROW",
            "path": "preferences.miscellaneousIssueEventCombined"
          }
        ]
      },
      "action": "THROW",
      "path": "preferences"
    }
  ],
  "type": "JiraNotificationProjectPreferences"
};
})();

(node as any).hash = "5edc2e126ed0810c509c3f64b7d71d71";

export default node;
